// extracted by mini-css-extract-plugin
export default {"loading-spinner":"LoadingSpinner_loading-spinner__FCUjs","message":"LoadingSpinner_message__kL-75"};